import {RaEvent, RaEventType} from "../event/RaEvent";
import {ISelection} from  "../api/data-model";

export enum PIPELINE_API_STATUS {
    start = 0,
    finish = 1,
    startglossary = 2,
    finishglossary = 3
}

export class PipelineSaveEvent extends RaEvent {

    static TYPE:RaEventType = "pipeline_save_event";

    constructor(private _status:PIPELINE_API_STATUS, private _selection?:ISelection) {
        super(PipelineSaveEvent.TYPE);
    }

    public get status():PIPELINE_API_STATUS{
        return this._status;
    }

    public get selection():ISelection {
        return this._selection;
    }

    public set selection(selection:ISelection) {
        this._selection = selection;
    }
}
